export default "__VITE_ASSET__P3puUs_btQi1Yp3AZFGpMA__"